// This is a workaround for an known issue integrating
// medium-editor-insert-plugin with medium editor.
// Do not use this for any other purpose.
//  https://github.com/orthes/medium-editor-insert-plugin/issues/408
import MediumEditor from 'medium-editor';
import _ from 'lodash';

const BackspaceWorkaroundExtension = MediumEditor.Extension.extend({
  name: 'backspace-workaround',

  init() {
    MediumEditor.Extension.prototype.init.call(this);
    this.subscribe('editableKeyup', this.handleBackspaceUp.bind(this));
  },

  handleBackspaceUp(event) {
    if (event.key === 'Backspace') {
      const value = _.get(_.first(_.values(this.base.serialize())), 'value');
      if (!value) {
        this.base.setContent('<p><br></p>');
      }
    }
  },
});

export default BackspaceWorkaroundExtension;
